// src/pages/products/WorkEikon.jsx
import React from 'react';
import ProductTemplate from '../../components/products/ProductTemplate';
import workEikonHero from '../../assets/images/expertise.jpg';
import workEikonProduct from '../../assets/images/expertise.jpg';

const WorkEikon = () => {
  const features = [
    { icon: '📋', title: 'Incident Management', description: 'Track, report, and analyze incidents in real-time' },
    { icon: '🔍', title: 'Inspection Management', description: 'Schedule and conduct digital inspections with ease' },
    { icon: '⚠️', title: 'BBO, Hazard ID & Near Miss', description: 'Identify and report hazards before they become incidents' },
    { icon: '🧪', title: 'Chemical Management', description: 'Track and manage hazardous materials safely' },
    { icon: '👥', title: 'JHSC Management', description: 'Streamline joint health and safety committee operations' },
    { icon: '🏗️', title: 'Asset Management', description: 'Track equipment maintenance and lifecycle' },
    { icon: '📚', title: 'Training Management', description: 'Manage employee training and certifications' },
    { icon: '📍', title: 'Site Specific Hazard Assessment', description: 'Custom hazard assessments per location' },
    { icon: '🔄', title: 'Return to Work Management', description: 'Manage employee return-to-work programs' },
    { icon: '💬', title: 'Meeting Management', description: 'Schedule and document safety meetings' },
    { icon: '🌱', title: 'Environmental Management', description: 'Track compliance with environmental regulations' },
    { icon: '✅', title: 'Action Item Management', description: 'Assign and track corrective actions' },
    { icon: '📁', title: 'Document Management', description: 'Centralized document storage and control' },
    { icon: '📊', title: 'Audit Management', description: 'Schedule and track internal/external audits' },
    { icon: '👷', title: 'Subcontractor Management', description: 'Manage subcontractor safety compliance' },
    { icon: '📄', title: 'Permit Management', description: 'Digital permit tracking and approvals' },
    { icon: '📢', title: 'Notice Board', description: 'Share bulletins and alerts with your team' }
  ];

  const benefits = [
    'Reduce workplace incidents by up to 60%',
    'Ensure compliance with OSHA, ISO 45001, and local regulations',
    'Save time with automated reporting and analytics',
    'Improve safety culture with real-time hazard reporting',
    'Centralize all EHS data in one secure platform',
    'Mobile-friendly access for field workers'
  ];

  const industries = [
    'Construction', 'Manufacturing', 'Mining', 'Oil & Gas',
    'Chemical Processing', 'Logistics', 'Healthcare', 'Utilities'
  ];

  const specifications = [
    { label: 'Deployment', value: 'Cloud-based (SaaS) / On-Premise' },
    { label: 'Platform', value: 'Web, iOS, Android' },
    { label: 'Security', value: 'SOC 2 Type II, GDPR Compliant' },
    { label: 'Integration', value: 'REST API, SSO, ERP Integration' },
    { label: 'Support', value: '24/7 Technical Support' },
    { label: 'Updates', value: 'Automatic monthly updates' },
    { label: 'Languages', value: 'Multiple languages supported' },
    { label: 'Certification', value: 'ISO 27001 Certified' }
  ];

  return (
    <ProductTemplate
      title="WorkEikon"
      badge="EHS SOFTWARE"
      tagline="Enterprise Health & Safety Management Solution"
      description="Where innovative EHS solutions meet the dynamic needs of modern workplaces. Our comprehensive software is designed to streamline your safety management processes, ensuring compliance, enhancing operational efficiency, and protecting your workforce."
      heroImage={workEikonHero}
      productImage={workEikonProduct}
      features={features}
      benefits={benefits}
      industries={industries}
      specifications={specifications}
      ctaText="Request Demo"
      ctaLink="/contact"
    />
  );
};

export default WorkEikon;